import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import DatePicker from 'react-date-picker'
import { DocumentDownloadIcon, QuestionMarkCircleIcon, SearchIcon } from '@heroicons/react/solid';
import { convert, formatDate } from '../../utils/convertDate';
import Paginate from '../../utils/Paginate';
import { useNavigate } from 'react-router-dom';
import WakanowServices from '../../services/wakanowServices';
import { toast } from 'react-toastify';
import Modal from '../../components/Modals/Modal';

const oldFrom = new Date().setDate(new Date().getDate() - 7);
const longNew = formatDate(new Date());
const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))

const HolidayPackages = () => {
    const navigate = useNavigate()

    const [search, setSearch] = useState("")
    const [too, setToo] = useState(convert(longNew));
    const [fromm, setFromm] = useState(convert(defaultFrom));
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    });

    const [filters, setFilters] = useState({
        search: '',
        fromm: convert(defaultFrom),
        too: convert(longNew),
    });

    const [pageIndex, setPageIndex] = useState(1);
    const itemsPerPage = 10;

    const [listings, setListings] = useState([]);
    const [totalListingsCount, setTotalListingsCount] = useState(0);
    const [totalPagesCount, setTotalPagesCount] = useState(0);

    const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);
    const [itemToDeactivate, setItemToDeactivate] = useState(null);

    const prevPage = () => {
        if (pageIndex > 1) setPageIndex(pageIndex - 1);
    };

    const nextPage = () => {
        if (pageIndex < totalPagesCount) setPageIndex(pageIndex + 1);
    }

    const GetListings = async (page, pageSize, searchTerm, startDate, endDate) => {
        try {
            const response = await WakanowServices.listHolidayPackages(page, pageSize, searchTerm, startDate, endDate);
            setListings(response.data.result);
            setTotalListingsCount(response.data.totalCount);
            setTotalPagesCount(Math.ceil(response.data.totalCount / itemsPerPage));
        } catch (error) {
            setListings([]);
            setTotalListingsCount(0);
            setTotalPagesCount(0);
        }
    }

    useEffect(() => {
        GetListings(pageIndex, itemsPerPage, filters.search, filters.fromm, filters.too);
    }, [pageIndex, filters])

    const range = async (e) => {
        e.preventDefault();
        setPageIndex(1);
        setFilters({ search, fromm, too });
    }

    const clearFilters = () => {
        setSearch("");
        setFormValues({ from: new Date(oldFrom), to: new Date() });
        setFromm(convert(defaultFrom));
        setToo(convert(longNew));
        setPageIndex(1);
        setFilters({
            search: '',
            fromm: convert(defaultFrom),
            too: convert(longNew),
        });
    };

    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event });
            setFromm(event ? convert(formatDate(event)) : '');
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event });
            setToo(event ? convert(formatDate(event)) : '');
        }
    };

    const exportData = async () => {
        const resp = await WakanowServices.exportHolidayPackages(filters.search, filters.fromm, filters.too);
        if (resp) {
            window.open(resp.data)
        }
    }

    const handleDeactivateConfirm = async () => {
        if (itemToDeactivate) {
            const response = await WakanowServices.deactivateHolidayPackage(itemToDeactivate.holidayPackageId)
            if (response) {
                toast.success(response.message)
                setIsDeactivateModalOpen(false);
                setItemToDeactivate(null);
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
            }
        }
    };

    const handleDeactivateCancel = () => {
        setIsDeactivateModalOpen(false);
        setItemToDeactivate(null);
    };

    return (
        <Layout title="Holiday Packages" pageTag={"wakanow"} current={'/wakanow/holiday-packages'}>
            <React.Fragment>
                <main className='mt-5'>
                    <div className="sm:flex items-center flex-wrap">
                        <div className="sm:flex-auto flex items-center flex-wrap">
                            <div className="relative rounded-md shadow-sm">
                                <p className='text-sm leading-3 text-gray-500'>From</p>
                                <div>
                                    <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                </div>
                            </div>
                            <div className="relative rounded-md shadow-sm ml-3">
                                <p className='text-sm leading-3 text-gray-500'>To</p>
                                <div>
                                    <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                </div>
                            </div>
                            <div className='flex ml-4'>
                                <div className="mt-5 relative rounded-md shadow-sm">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </div>
                                    <input
                                        type="text"
                                        onChange={(e) => setSearch(e.target.value)}
                                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                        placeholder="Search packages"
                                    />
                                    <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                                        <div className='tooltip'>
                                            <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                            <span className="tooltiptext"><p>Search by name or destination</p></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-5 ml-4'>
                                <button
                                    onClick={range}
                                    className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'
                                >
                                    Search
                                </button>
                            </div>
                            <div className='mt-5 ml-4'>
                                <button
                                    onClick={clearFilters}
                                    className='inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-6 py-2 text-sm font-medium text-gray-600 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'
                                >
                                    Clear filters
                                </button>
                            </div>
                        </div>

                        <div className="flex items-center mt-3">
                            <button
                                onClick={() => navigate("/wakanow/holiday-packages/create")}
                                className="inline-flex mr-2 items-center text-white active:text-white justify-center rounded-md border border-transparent bg-red-600 px-2 py-2 text-sm font-medium shadow-sm sm:w-auto"
                            >
                                Create Holiday Package
                            </button>
                            <button
                                type="button"
                                onClick={exportData}
                                className="inline-flex mr-2 items-center hover:text-white active:text-white justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm sm:w-auto"
                            >
                                <DocumentDownloadIcon className="w-4 mr-1.5" />
                                Export
                            </button>
                        </div>
                    </div>

                    {listings.length === 0 ? (
                        <div className="text-center py-16">
                            <p className="text-gray-500 text-lg">No holiday packages found</p>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                            {listings.map((item) => {
                                const isDeleted = item.isDeleted || item.status?.toLowerCase() === 'deactivated';
                                return (
                                    <div key={item.holidayPackageId} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200">
                                        <div className="relative h-48 overflow-hidden bg-gray-100">
                                            {item.imageUrls?.[0] ? (
                                                <img
                                                    src={item.imageUrls[0]}
                                                    alt={item.packageName}
                                                    className="w-full h-full object-cover"
                                                    onError={(e) => { e.target.src = ''; e.target.style.display = 'none'; }}
                                                />
                                            ) : (
                                                <div className="w-full h-full flex items-center justify-center">
                                                    <svg className="w-12 h-12 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                    </svg>
                                                </div>
                                            )}
                                            {item.imageUrls?.length > 1 && (
                                                <span className="absolute bottom-3 right-3 bg-black/60 text-white text-xs font-semibold px-2 py-0.5 rounded-full shadow-sm">
                                                    +{item.imageUrls.length - 1}
                                                </span>
                                            )}
                                            <span className={`absolute top-3 right-3 px-2.5 py-1 text-xs font-semibold rounded-full shadow-sm ${isDeleted ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                                                {item.status || (isDeleted ? 'Deactivated' : 'Active')}
                                            </span>
                                        </div>
                                        <div className="p-5">
                                            <div className="flex items-start justify-between">
                                                <div className="flex-1 min-w-0">
                                                    <h3 className="text-lg font-bold text-gray-900 truncate">{item.packageName}</h3>
                                                    <p className="text-sm text-gray-500 mt-0.5">{item.destination}</p>
                                                </div>
                                            </div>
                                            <p className="text-sm text-gray-400 mt-1">
                                                <span className="inline-flex items-center">
                                                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                    </svg>
                                                    {item.travelPeriod}
                                                </span>
                                            </p>
                                            <p className="text-sm font-semibold text-gray-900 mt-2">
                                                <span className="inline-flex items-center">
                                                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                    </svg>
                                                    {item.startingPrice !== undefined && item.startingPrice !== null
                                                        ? `₦${parseFloat(item.startingPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                                        : 'N/A'}
                                                </span>
                                            </p>
                                            <div className="flex items-center mt-3 pt-3 border-t border-gray-100">
                                                <span className={`inline-flex items-center text-xs font-medium px-2.5 py-1 rounded-full ${item.isFlightIncluded ? 'bg-blue-50 text-blue-700' : 'bg-gray-50 text-gray-500'}`}>
                                                    <svg className="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                                                    </svg>
                                                    {item.isFlightIncluded ? 'Flight Included' : 'No Flight'}
                                                </span>
                                            </div>
                                            <div className="flex gap-2 mt-4">
                                                <button
                                                    onClick={() => navigate(`/wakanow/holiday-packages/view?${item.holidayPackageId}`)}
                                                    className="flex-1 text-sm font-medium px-3 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
                                                >
                                                    View
                                                </button>
                                                <button
                                                    onClick={() => navigate(`/wakanow/holiday-packages/edit?${item.holidayPackageId}`)}
                                                    className="flex-1 text-sm font-medium px-3 py-2 rounded-lg bg-gray-800 text-white hover:bg-gray-700 transition-colors"
                                                >
                                                    Edit
                                                </button>
                                            </div>
                                            {!isDeleted && (
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setItemToDeactivate(item);
                                                        setIsDeactivateModalOpen(true);
                                                    }}
                                                    className="mt-2 w-full inline-flex items-center justify-center rounded-lg bg-red-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors"
                                                >
                                                    Deactivate
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    <Paginate
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        totalCount={totalListingsCount}
                        totalPages={totalPagesCount}
                        prevPage={prevPage}
                        setPageIndex={setPageIndex}
                    />

                    <Modal
                        isOpen={isDeactivateModalOpen}
                        onClose={handleDeactivateCancel}
                        onConfirm={handleDeactivateConfirm}
                        onCancel={handleDeactivateCancel}
                        modalTitle="Deactivate Holiday Package"
                        modalText={`Are you sure you want to deactivate "${itemToDeactivate?.packageName}"?`}
                    />
                </main>
            </React.Fragment>
        </Layout>
    )
}

export default HolidayPackages
